/**
 * Bunny Shield API
 * Bunny.net API for Bunny Shield (WAF, DDoS, Rate Limiting, Bot Detection, Access Lists & API Guardian).

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 0 = IP 1 = Host 2 = Country 3 = City 4 = ASN 5 = Organization 6 = JA4 7 = IP_JA4
 */
export type WafRatelimitCounterKeyType = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;

export const WafRatelimitCounterKeyType = {
  IP: 0 as WafRatelimitCounterKeyType,
  Host: 1 as WafRatelimitCounterKeyType,
  Country: 2 as WafRatelimitCounterKeyType,
  City: 3 as WafRatelimitCounterKeyType,
  ASN: 4 as WafRatelimitCounterKeyType,
  Organization: 5 as WafRatelimitCounterKeyType,
  JA4: 6 as WafRatelimitCounterKeyType,
  IP_JA4: 7 as WafRatelimitCounterKeyType,
};
